import type { OrderId} from "@@/shared/orders/order-id";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    IsoAndUnixTimestamp} from "../../date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "../../date-time/iso-and-unix";
import { idZodSchema } from "../../id";
import type { PrinterId} from "../printer-id";
import { printerIdZodSchema } from "../printer-id";

type PrintDeliverySlipCommand = {
    readonly _id: string;
    readonly _type: "PRINT_DELIVERY_SLIP_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;

    readonly orderId: OrderId;
    readonly printerId: PrinterId;
    readonly providerId: ProviderId;
};

type FactoryParams = Except<
    PrintDeliverySlipCommand,
    "_id" | "_type" | "_createdAt"
>;
const printDeliverySlipCommandFactory = (params: FactoryParams) => {
    const command: PrintDeliverySlipCommand = {
        ...params,
        _id: generateId({ prefix: "print_delivery_slip_command__" }),
        _type: "PRINT_DELIVERY_SLIP_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const printDeliverySlipCommandIdZodSchema = idZodSchema.regex(
    /^print_delivery_slip_command__.*$/,
);
const printDeliverySlipCommandZodSchema: z.ZodSchema<PrintDeliverySlipCommand> =
    z.object({
        _id: printDeliverySlipCommandIdZodSchema,
        _type: z.literal("PRINT_DELIVERY_SLIP_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        orderId: orderIdZodSchema,
        printerId: printerIdZodSchema,
        providerId: providerIdZodSchema,
    });

export {
    printDeliverySlipCommandFactory,
    printDeliverySlipCommandIdZodSchema,
    printDeliverySlipCommandZodSchema,
};
export type {
    FactoryParams as CreatePrintDeliverySlipCommandParams,
    PrintDeliverySlipCommand,
};
